<template>
  <div ref="chartRef" style="width: 100%;height: 100%"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { nextTick, onMounted, ref, watch } from "vue";

const props = defineProps(["data"]);

const chartRef = ref(null);
let chartInstance = null;

const init = () => {
  chartInstance = echarts.init(chartRef.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart(val);
  },
  { deep: true }
);

const setChart = (val) => {
  const option = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: 0,
      left: 0,
      right: 20,
      bottom: 20,
      containLabel: true
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      splitLine:{
      show:false // 不显示网格线
      },
      axisLabel: {
        color: '#6FCAF7', // 设置文字颜色
      }
    },
    yAxis: [
      {
        type: 'category',
        data: val.map(item => item.displayText),
        axisTick:{
          show:false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false, // 不显示坐标轴线
        },
        axisLabel: {
          color: '#6FCAF7', // 设置文字颜色
        }
      },
      {
        type: 'category',
        data: val.map(item =>{
          let color = '#6FCAF7';
          if(item.colorType == 3){
            color = '#FF7A68';
          }else if(item.colorType == 2){
            color = '#FDC631';
          }else{
            color = '#6FCAF7'
          }
          return {
            value: `${item.displayText}${item.value}次`,
            textStyle: {
              color: color,
            }
          }
        }),
        axisTick:{
          show:false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false, // 不显示坐标轴线
        },
      },
    ],
    series: [
      {
        name: "",
        type: "bar",
        data: val.map(item => {
          return {
            name: item.displayText,
            value: item.value,
            ...item,
          }
        }),
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(58,198,190,0.2)',
          borderRadius: 999,
        },
        itemStyle: {
          borderRadius: 999, // 设置柱状图的圆角
          color: function({data}) {
            // 根据数据值设置柱状图的颜色
            if (data.colorType == 3) {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#FF573C" },
                { offset: 1, color: "#FFB2AF" },
              ])
            }else if (data.colorType == 2) {
              return  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#FF9400" },
                { offset: 1, color: "#FFCF8E" },
              ])
            }else{
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#5FB9FE" },
                { offset: 1, color: "#A5F3FF" },
              ])
            }
          }
        },
        barWidth: 12, // 设置柱状图的宽度
      },
    ],
  };
  chartInstance && chartInstance.setOption(option);
          // 窗口尺寸变化时自动调整图表大小
        window.addEventListener('resize', function() {
            chartInstance.resize();
        });
}
</script>

<style lang="scss" scoped>

</style>